import { getImageList } from "../../../../../redux/slices/productSlice";
import { store } from "../../../../../redux/store";

export const deleteImage = (item, imageList) => {
  const filteredImages = [...imageList];
  const index = filteredImages.indexOf(item);
  if (index > -1) {
    filteredImages.splice(index, 1);
  }
  store.dispatch(getImageList(filteredImages));
};
